import { isDefined } from '../../helpers'
import { Format, Optional } from '../../types/core'
import { MultipleRoleVat, RoleVat } from './types'

export const isMultipleRoleVat = (roleVat: RoleVat): roleVat is MultipleRoleVat =>
  isDefined(roleVat.isCollectorVatRegistered) && isDefined(roleVat.isCustomerVatRegistered)

export const formatVatRegistered: Format<Optional<boolean>> = isRegistered =>
  isRegistered ? 'registered' : 'non-registered'
